
export class DirectoryListingCategory {
  public id: string;
  public code: string;
  public label: string;
  public icon: string;
}
